<!--
 * @Description: 终端要货清单详情
 * @Autor: txp
 * @Date: 2021-05-07 17:29:05
-->
<template>
  <div class="terminallistdet">
    <el-card class="box-card">
      <div class="mtb20 ft12 C787878">
        <span>服务中心：</span>
        <span>
          <a href="#" class="text-decoration_none themColor" @click="goHomes">返回上一页</a>
        </span>
        <span class="el-icon-arrow-right"></span>
        <span>要货详情</span>
      </div>
      <div
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        class="terminallistdet_con"
      >
        <!-- 订单数据 -->
        <!-- <div class="orderData">
                <p class="order_title">订单结算信息</p>
                <div class="padding20 ft14 userInfo">
                    <div v-for="(item,index) in TerminallistDetInfoArrs" :key="index">
                        <span>{{item.name}}</span>
                        <span>{{item.val}}</span>
                    </div>
                </div>
            </div> -->
        <!-- 商品数据 -->
        <div class="prouctData">
          <p class="order_title">商品数据</p>
          <el-table
            ref="terminallistdetId"
            border
            :data="table_data"
            :header-cell-style="{
              textAlign: 'center',
              fontSize: '13px',
              color: '#787878',
              background: '#F5F5F5'
            }"
            :cell-style="{
              textAlign: 'center',
              fontSize: '14px',
              color: '#1D1D1D',
              lineHeight: '24px'
            }"
          >
            <el-table-column fixed="left" label="图片">
              <template slot-scope="scope">
                <img
                  width="50px"
                  height="50px"
                  :src="scope.row.tprimaryPictureUrl ? scope.row.tprimaryPictureUrl : noPic"
                />
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item, index) in table_data_head"
              :key="index"
              width="200px"
              :prop="item.prop"
              :label="item.label"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="order_btn">
        <el-button @click="goHomes" size="small" type="primary">关闭</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import { SfaWorkDailyController } from '@/api/terminalOrderlist'
import { mdmdictdata } from '@/api/api'
import noPic from '@/assets/img/no_goods.png'
export default {
  name: 'terminallistdet',
  data() {
    return {
      TerminallistDetInfo: {},
      selectValList: [],
      loading: true,
      noPic,
      table_data_head: [
        // {label:"序号",prop:"index"},
        // {label:"图片",prop:"primaryPictureUrl"},
        // {label:"价格",prop:"price"},
        { label: '商品编码', prop: 'productCode' },
        { label: '产品名称', prop: 'productName' },
        { label: '单位', prop: 'unitName' },
        { label: '数量', prop: 'quantity' },
        { label: '订单号', prop: 'orderCode' },
        { label: '客户编码', prop: 'customerCode' },
        { label: '客户名称', prop: 'customerName' },
        { label: '人员名称', prop: 'createName' },
        { label: '联系人', prop: 'contacts' },
        { label: '联系电话', prop: 'telephone' },
        { label: '期望到货日期', prop: 'expectReceive' },
        { label: '下单日期', prop: 'orderTime' },
        { label: '收货地址', prop: 'address' },
        { label: '备注', prop: 'remarks' }
      ],
      table_data: []
    }
  },
  computed: {
    TerminallistDetInfoArrs() {
      return [
        { name: '终端编码：', val: this.TerminallistDetInfo.orderCode },
        { name: '终端编码：', val: this.TerminallistDetInfo.clientCode },
        { name: '终端名称：', val: this.TerminallistDetInfo.clientName },
        { name: '下单人员：', val: this.TerminallistDetInfo.realName },
        { name: '下单人员职位：', val: this.TerminallistDetInfo.posName },
        { name: '下单人员组织：', val: this.TerminallistDetInfo.orgName },
        { name: '联系人：', val: this.TerminallistDetInfo.contacts },
        { name: '联系电话：', val: this.TerminallistDetInfo.telephone },
        { name: '期望到货日期：', val: this.TerminallistDetInfo.expectReceive },
        { name: '下单日期：', val: this.TerminallistDetInfo.orderTime },
        { name: '上级客户：', val: this.TerminallistDetInfo.customerName },
        { name: '收货地址：', val: this.TerminallistDetInfo.address },
        { name: '订单状态：', val: this.TerminallistDetInfo.approval }
      ]
    }
  },
  created() {
    this.TerminallistDets()
  },
  methods: {
    // 获取订单状态编码
    async mdmdictdatas() {
      await mdmdictdata({
        dictTypeCode: 'sfa_approval'
      }).then((res) => {
        if (res.code == 200) {
          this.selectValList = res.result
        }
      })
    },
    // 获取订单详情
    TerminallistDets() {
      let params = {
        orderId: this.$route.query.id
      }
      SfaWorkDailyController(params).then(async (res) => {
        await this.mdmdictdatas()
        // 转换订单状态
        // res.result.approval = this.selectValList.find(it=>it.dictCode === res.result.approvalStatus).dictValue
        // 订单信息
        this.TerminallistDetInfo = res.result
        const {
          orderCode,
          customerCode,
          customerName,
          contacts,
          telephone,
          address,
          remarks,
          expectReceive,
          orderTime,
          createName
        } = res.result
        // 新增商品数据序号
        res.result.sfaTerminalProductVos.forEach((item, index) => {
          if (index < 8) {
            item.index = 0 + `${index + 1}`
          } else {
            item.index = index + 1
          }
          item.orderCode = orderCode
          item.customerCode = customerCode
          item.customerName = customerName
          item.contacts = contacts
          item.telephone = telephone
          item.address = address
          item.remarks = remarks
          item.expectReceive = expectReceive
          item.orderTime = orderTime
          item.createName = createName
        })

        // 商品数据
        this.table_data = res.result.sfaTerminalProductVos
        console.log(this.table_data[0].primaryPictureUrl)
        this.loading = false
      })
    },
    goHomes() {
      window.history.back()
    }
  }
}
</script>
<style lang="scss" scoped>
.terminallistdet {
  height: 100%;
  /deep/ .el-card {
    height: 100%;
    position: relative;
    .terminallistdet_con {
      .order_title {
        color: #000;
        margin: 20px 0px;
        font-weight: bold;
      }
      .orderData {
        .userInfo {
          border: 1px solid #d8d8d8;
          border-radius: 4px;
          display: flex;
          flex-wrap: wrap;
          div {
            width: 30%;
            line-height: 30px;
            span {
              display: inline-block;
              &:first-child {
                width: 100px;
                color: #787878;
              }
              &:last-child {
                color: #000;
              }
            }
          }
        }
      }
    }
    .order_btn {
      position: absolute;
      bottom: 40px;
      right: 40px;
    }
  }
}
</style>
